// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__27m1B","errors":"Errors_errors__3acrM"};